import React from 'react';
// formik
import { FieldArray } from 'formik';
//mui
import { Box } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import PurchaseForm from './PurchaseForm';

const PurchaseBillFormList = ({ formik, ArrayHelperRef }) => {
  const handleDelete = (index) => {
    ArrayHelperRef.current.remove(index);
  };

  return (
    <FieldArray
      name="purchaseBills"
      render={(arrayHelpers) => {
        ArrayHelperRef.current = arrayHelpers;
        return (
          <Box>
            <TableContainer
              size="small"
              //className={classes.table}
              sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}
            >
              <Table padding="none">
                <TableHead>
                  <TableRow>
                    <TableCell>No</TableCell>
                    <TableCell align="center">매입일자</TableCell>
                    <TableCell>매입처</TableCell>
                    <TableCell>매입내용</TableCell>
                    <TableCell align="center">해외 거래</TableCell>
                    <TableCell align="center">총매입금액</TableCell>
                    <TableCell align="center">기매입금액</TableCell>
                    <TableCell align="center">매입합계</TableCell>
                    <TableCell align="center">매입금액</TableCell>
                    <TableCell align="center">부가세</TableCell>
                    <TableCell align="center">지급예정일자</TableCell>
                    <TableCell align="center">매입횟수</TableCell>
                    <TableCell align="center">삭제</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {formik.values?.purchaseBills &&
                    formik.values?.purchaseBills.map((bill, index) => {
                      return (
                        <PurchaseForm
                          key={index}
                          index={index}
                          bill={bill}
                          formik={formik}
                          onDelete={handleDelete}
                        />
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        );
      }}
    ></FieldArray>
  );
};

export default PurchaseBillFormList;
